<!-- Confirm Dialog Component Template -->
<!-- @feature 011-patient-lifecycle-permissions -->

<div class="confirm-dialog" [class]="'confirm-dialog--' + dialogType">
  <!-- Header with optional icon -->
  <h2 mat-dialog-title class="confirm-dialog__title">
    @if (icon) {
      <mat-icon class="confirm-dialog__icon" [attr.aria-hidden]="true">
        {{ icon }}
      </mat-icon>
    }
    <span>{{ data.titleKey | translate }}</span>
  </h2>

  <!-- Message content -->
  <mat-dialog-content class="confirm-dialog__content">
    <p class="confirm-dialog__message">
      {{ data.messageKey | translate: data.messageParams }}
    </p>
  </mat-dialog-content>

  <!-- Action buttons -->
  <mat-dialog-actions class="confirm-dialog__actions" align="end">
    @if (showCancelButton) {
      <button
        mat-button
        type="button"
        class="confirm-dialog__cancel-btn"
        (click)="onCancel()"
        [attr.aria-label]="cancelKey | translate">
        {{ cancelKey | translate }}
      </button>
    }
    <button
      mat-raised-button
      type="button"
      class="confirm-dialog__confirm-btn"
      [class]="'confirm-dialog__confirm-btn--' + dialogType"
      (click)="onConfirm()"
      [attr.aria-label]="confirmKey | translate"
      cdkFocusInitial>
      {{ confirmKey | translate }}
    </button>
  </mat-dialog-actions>
</div>
